import { makeStyles } from '@material-ui/core/styles'

const styles = () => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    minWidth: 120,
  },
  formHelperText: {
    fontSize: '0.875rem',
  },
  button: {
    flexShrink: 0,
    position: 'absolute',
  },
  errorText: {
    color: '#C60000',
    fontWeight: 700,
    fontSize: 18,
  },
})

export default makeStyles(styles)
